// assets/delivery-cutoff-tooltip.js
(() => {
  const TOOLTIP_TEXT =
    "Cut-off time: 1:00pm Monday-Friday, 11:00am Saturday, closed Sunday. (Orders placed after 1:00 pm will be automatically scheduled for delivery on the next business day or dispatched on your specified date.)";

  // 你标题的选择器：根据截图，“Pick your delivery date:” 很可能是一个普通文本元素
  // 这里用“文本匹配”去找，最通用（适配 DATO 不同主题的包裹结构）
  function findLabelNode() {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT);
    let node;
    while ((node = walker.nextNode())) {
      const text = (node.textContent || "").trim();
      if (text === "Pick your delivery date:" || text.startsWith("Pick your delivery date:")) {
        // 避免找到父容器（里面还有很多文字），只要“看起来像标题”的
        const childrenText = Array.from(node.children || []).map((c) => (c.textContent || "").trim()).join(" ");
        if (childrenText.length < 5) return node;
      }
    }
    return null;
  }

  function inject(labelEl) {
    if (!labelEl || labelEl.__cutoffTooltipInjected) return;
    labelEl.__cutoffTooltipInjected = true;

    // wrapper 让图标在文字右侧
    const wrap = document.createElement("span");
    wrap.className = "cutoff-tooltip-wrap";
    wrap.setAttribute("tabindex", "0"); // keyboard focus

    wrap.innerHTML = `
      <span class="cutoff-tooltip-icon" aria-label="Cut-off time information" role="img">i</span>
      <span class="cutoff-tooltip-bubble" role="tooltip"></span>
    `;

    wrap.querySelector(".cutoff-tooltip-bubble").textContent = TOOLTIP_TEXT;

    // 插到标题后面
    labelEl.appendChild(wrap);
  }

  function init() {
    const label = findLabelNode();
    if (label) inject(label);
  }

  // 初次 + 监听 DATO 动态渲染
  const obs = new MutationObserver(() => init());
  obs.observe(document.documentElement, { childList: true, subtree: true });

  init();
})();